import { AccountApproverEntry } from '@ariksa/jit/api';
import { uniq } from 'lodash';

// Approver emails for a data group: its own plus the account-wide ones
// (data_group_id null), since both can approve its requests. De-duplicated so
// someone set at both levels shows once.
export const getDataGroupApproverEmails = (
  approvers: AccountApproverEntry[] = [],
) => uniq(approvers.map(approver => approver.email).filter(Boolean));

// Formats the auto-approval limit like "4h" or "30m"; '-' when not set.
export const formatAutoApprovalDuration = (seconds?: number | null) => {
  if (!seconds) return '-';
  const minutes = Math.round(seconds / 60);
  return minutes % 60 === 0 ? `${minutes / 60}h` : `${minutes}m`;
};
